module.exports = __webpack_public_path__ + "static/media/s_gray.a7d6d8df.mp3";